<template>
    <syain-list />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import SyainList from '@/components/syain/Search.vue'
import { useSyainStore } from "@/store/syain"
import { RouterConst } from "@/const/Router"
import { onBeforeRouteLeave } from 'vue-router'

export default defineComponent({
  beforeRouteEnter(to, from, next){
    const syainStore = useSyainStore();
    if(from.name != RouterConst.SYAIN_DETAIL){
      // 検索情報の削除
      syainStore.removeItem();
    }
    next()
  },
  setup() {
    const syainStore = useSyainStore();
    onBeforeRouteLeave((to, from, next) => {
      if(to.name != RouterConst.SYAIN_DETAIL){
        // 検索情報の削除
        syainStore.removeItem();
      }
      next()
    })

    return {}
  },
  components: {
    'syain-list': SyainList
  }
})
</script>
